import {inject} from '@angular/core';
import {Router, Routes} from '@angular/router';
import {UserGuard} from './core/auth/guards/user.guard';
import {MenuRoutes} from './routes/menu.routes';
import {SaleRoutes} from './routes/sales.routes';
import {PurchasesRoutes} from './routes/purchases.routes';
import {PlanningRoutes} from './routes/planning.routes';
import {TabsPage} from './pages/tabs/tabs.page';
import {AdminRoutes} from './domains/admin/admin.routes';

export const appRoutes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    },

    // ADMIN
    {
        path: 'admin',
        children: AdminRoutes,
    },

    {
        path: 'register',
        loadComponent: () => import('./pages/register/register.page').then(m => m.RegisterPage),
    },

    {
        path: 'registro-tienda',
        loadComponent: () =>
            import('./pages/store-onboarding/store-onboarding.page').then(m => m.StoreOnboardingPage),
    },

    {
        path: 'account-deletion',
        loadComponent: () => import('./pages/account-deletion/account-deletion.page').then(m => m.AccountDeletionPage),
    },

    // Documentos legales públicos (sin sesión) — URLs registrados en
    // Google Play Console / App Store Connect. Ver src/app/core/legal/.
    {
        path: 'terminos-y-condiciones',
        loadComponent: () =>
            import('./pages/legal/terms-conditions/terms-conditions.page').then(m => m.TermsConditionsPage),
    },
    {
        path: 'politica-de-privacidad',
        loadComponent: () =>
            import('./pages/legal/privacy-policy/privacy-policy.page').then(m => m.PrivacyPolicyPage),
    },

    {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPage),
    },

    // Redirección de compatibilidad para enlaces legados /main/tabs/...
    {
        path: 'main/tabs',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '/',
            },
            {
                path: '**',
                redirectTo: (snapshot) => {
                    const router = inject(Router);
                    const remaining = snapshot.url.map((s) => s.path).join('/');
                    const target = remaining ? '/' + remaining : '/';
                    return router.createUrlTree([target], {
                        queryParams: snapshot.queryParams,
                        fragment: snapshot.fragment ?? undefined,
                    });
                },
            },
        ],
    },

    // APP (protegida)
    {
        path: '',
        canActivate: [UserGuard],
        component: TabsPage,
        children: [
            {path: 'branch-sales', children: SaleRoutes},
            {path: 'branch-purchases', children: PurchasesRoutes},
            {path: 'planning-container', children: PlanningRoutes},
            {path: 'menu', children: MenuRoutes},
            {path: '', redirectTo: 'menu', pathMatch: 'full'},
        ],
    },
    {
        path: '**',
        redirectTo: 'not-found',
    },
];
